import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import AppStore from 'store/AppStore'
import { configureStore } from 'client/redux/store'


// Initialize store
const store = configureStore(window.__INITIAL_STATE__)
const mountApp = document.getElementById('root')
const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate

renderMethod(
  <AppContainer>
    <AppStore store={store} />
  </AppContainer>,
  mountApp
)

// For hot reloading of react components
if (module.hot) {
  module.hot.accept('./AppStore', () => {
    // If you use Webpack 2 in ES modules mode, you can
    // use <App /> here rather than require() a <NextApp />.
    const NextApp = require('./AppStore').default // eslint-disable-line global-require
    renderMethod(
      <AppContainer>
        <NextApp store={store} />
      </AppContainer>,
      mountApp
    )
  })
}
